import { api } from "../../lib/api";

const seen = new Set();

export const trackPromo = (id, type, itemCode) => {
  const key = `${id}:${type}:${itemCode || ""}`;
  if (type === "view" && seen.has(key)) return;
  seen.add(key);
  api.post(`/promotions/${id}/events`, { type, item_code: itemCode || null }).catch(() => {});
};

export const promoByItem = (promos) => {
  const map = {};
  (promos || []).forEach((p) => p.item_codes.forEach((c) => { if (!map[c]) map[c] = p; }));
  return map;
};

export const mediaUrl = (path) => (path && path.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path);
